<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.3538 6.35354L8.35375 11.3535C8.30732 11.4 8.25217 11.4369 8.19147 11.4621C8.13077 11.4872 8.06571 11.5002 8 11.5002C7.9343 11.5002 7.86923 11.4872 7.80853 11.4621C7.74783 11.4369 7.69269 11.4 7.64625 11.3535L2.64625 6.35354C2.55243 6.25972 2.49973 6.13247 2.49973 5.99979C2.49973 5.86711 2.55243 5.73986 2.64625 5.64604C2.74007 5.55222 2.86732 5.49951 3 5.49951C3.13269 5.49951 3.25993 5.55222 3.35375 5.64604L8 10.2929L12.6463 5.64604C12.6927 5.59958 12.7479 5.56273 12.8086 5.53759C12.8693 5.51245 12.9343 5.49951 13 5.49951C13.0657 5.49951 13.1308 5.51245 13.1915 5.53759C13.2521 5.56273 13.3073 5.59958 13.3538 5.64604C13.4002 5.69249 13.4371 5.74764 13.4622 5.80834C13.4873 5.86904 13.5003 5.93409 13.5003 5.99979C13.5003 6.06549 13.4873 6.13054 13.4622 6.19124C13.4371 6.25193 13.4002 6.30708 13.3538 6.35354Z"
      fill="#4E4E4E"
    />
  </svg>
</template>

<script>
export default {
  name: "CaretDownFormIcon",
};
</script>
